import { MerchantStructure, User } from '@nemuru-eng/js-api-client';
import { useEffect, useState } from 'react';

import { UserInStructure } from '@/types/UserInStructure';

interface UseChangerUserProps {
  merchantStructure: MerchantStructure;
  selectedUser: User;
}

export const useChangeUserSearch = ({ merchantStructure, selectedUser }: UseChangerUserProps) => {
  const [searchString, setSearchString] = useState<string | undefined>(undefined);
  const [searchResult, setSearchResult] = useState<UserInStructure[] | undefined>([]);
  const [selectedDestination, setSelectedDestination] = useState<UserInStructure | undefined>();

  const minimumSearchStringForResults = searchString && searchString?.length > 2;

  useEffect(() => {
    return () => {
      setSearchResult(undefined);
      setSearchString(undefined);
      setSelectedDestination(undefined);
    };
  }, []);

  useEffect(() => {
    if (minimumSearchStringForResults) {
      searchInMerchantStructure(searchString);
    } else {
      setSearchResult(undefined);
      setSelectedDestination(undefined);
    }
  }, [searchString]);

  const searchInMerchantStructure = (searchString: string) => {
    const merchant = merchantStructure.merchant;

    const matchedMerchant = [merchant].filter(
      (merchant) =>
        merchant.businessName.toLowerCase().includes(searchString) || merchant.id.toLowerCase().includes(searchString),
    );

    const matchedChannels = merchant.channels.filter(
      (channel) =>
        channel.description?.toLowerCase().includes(searchString) ||
        channel.username?.toLowerCase().includes(searchString) ||
        channel.id?.toLowerCase().includes(searchString),
    );
    const matchedAgents = merchant.channels.flatMap((channel) => {
      return channel.agents.filter(
        (agent) =>
          agent.username?.toLowerCase().includes(searchString) ||
          agent.name?.toLowerCase().includes(searchString) ||
          agent.id?.toLowerCase().includes(searchString),
      );
    });
    setSearchResult(
      [...matchedMerchant, ...matchedChannels, ...matchedAgents]
        .flatMap((e) => e)
        .filter((e) => e.id !== selectedUser.userId),
    );
  };

  return {
    searchResult,
    selectedDestination,
    setSearchResult,
    setSearchString,
    setSelectedDestination,
    minimumSearchStringForResults,
  };
};
